const GATEWAY_DEV_COMMAND = 'pnpm --filter @lineage/api-gateway dev';

function computeSuggestedUrl(configuredUrl: string, defaultSuggestion?: string) {
  if (!configuredUrl) return defaultSuggestion ?? '/api/v1';
  if (configuredUrl.includes('3001')) {
    return configuredUrl.replace('3001', '3101');
  }
  return defaultSuggestion ?? configuredUrl;
}

export function buildGatewayNetworkError(options: {
  context: string;
  configuredUrl: string;
  envVar?: string;
  serviceName?: string;
  detail: unknown;
  suggestion?: string;
}) {
  const { context, configuredUrl, envVar, serviceName, suggestion, detail } = options;

  // Better error detail formatting
  let detailText: string;
  if (detail instanceof Error) {
    detailText = detail.message;
  } else if (typeof detail === 'object' && detail !== null) {
    // Try to extract meaningful info from error objects
    const errorObj = detail as any;
    if (errorObj.message) {
      detailText = String(errorObj.message);
    } else if (errorObj.code) {
      detailText = `Error code: ${errorObj.code}`;
    } else {
      detailText = 'Failed to fetch';
    }
  } else if (typeof detail === 'string' && detail.trim().length > 0) {
    detailText = detail;
  } else {
    detailText = 'Network error';
  }

  const suggestedUrl = computeSuggestedUrl(configuredUrl, suggestion);
  const envHint = envVar
    ? `y que ${envVar} apunte a ${suggestedUrl}`
    : `y que la configuración del frontend apunte a ${suggestedUrl}`;

  return new Error(
    `${context}. No se pudo contactar al ${serviceName ?? 'API Gateway'} usando "${configuredUrl}". ` +
      `Asegúrate de que el gateway esté activo (${GATEWAY_DEV_COMMAND}) ${envHint}. ` +
      `Detalle técnico: ${detailText}`
  );
}
